import type { SubjectIndicatorsPayload } from '@Application/Indicators/Actions/subjectIndicatorsFetched';

/** Immutable View: the number of dossiers per dossier type, for one scope. */
class SubjectIndicatorsView {
	readonly queryKey: string;
	readonly counts: ReadonlyMap<number, number>;

	constructor(payload: SubjectIndicatorsPayload) {
		this.queryKey = payload.queryKey;
		this.counts = new Map(payload.counts.map((entry) => [entry.subjectType.id, entry.count]));

		Object.freeze(this);
	}

	/** `null` when the type has no entry. */
	countOf(typeId: number): number | null {
		return this.counts.get(typeId) ?? null;
	}
}

export default SubjectIndicatorsView;
